import { Calendar, ChevronRight, MapPin, Trophy } from "lucide-react";
import { Link } from "react-router-dom";
import SectionHeader from "@/components/ui/SectionHeader";

interface Event {
  id: string;
  name: string;
  date: string;
  location: string;
  category: string;
  description: string;
}

const events: Event[] = [
  {
    id: "3",
    name: "HÍBRIDO GAMES 2026 - 2ª EDIÇÃO",
    date: "14 e 15 de novembro de 2026",
    location: "João Pessoa - PB",
    category: "Etapa 03",
    description:
      "Terceira etapa oficial da Liga PB 2026 e segunda edição do Híbrido Games neste ano.",
  },
];

export default function UpcomingEvents() {
  return (
    <section className="py-16 md:py-24 bg-background border-t border-border">
      <div className="container mx-auto px-4">
        <SectionHeader
          subtitle="Calendário"
          title="Próximos eventos"
          description="A próxima etapa oficial da Liga PB já está definida no calendário da FPF3."
          className="mb-10"
        />

        <div className="mx-auto max-w-4xl space-y-4">
          {events.map((event) => (
            <article key={event.id} className="card-fpf3 p-5 md:p-6">
              <div className="flex flex-col gap-5 md:flex-row md:items-center md:gap-8">
                <div className="flex h-20 w-20 shrink-0 flex-col items-center justify-center rounded-sm border border-primary/25 bg-primary/10 p-2">
                  <Trophy size={20} className="mb-1 text-primary" />
                  <span className="w-full truncate text-center text-[10px] font-bold uppercase leading-tight tracking-[0.14em] text-primary">
                    {event.category}
                  </span>
                </div>

                <div className="min-w-0 flex-1">
                  <h3 className="font-display text-xl font-black uppercase leading-tight text-white md:text-2xl">
                    {event.name}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                    {event.description}
                  </p>
                  <div className="mt-4 flex flex-wrap gap-4 text-xs font-medium text-muted-foreground">
                    <span className="flex items-center gap-1.5">
                      <Calendar size={13} className="text-primary" />
                      {event.date}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <MapPin size={13} className="text-primary" />
                      {event.location}
                    </span>
                  </div>
                </div>

                <Link
                  to="/eventos"
                  className="inline-flex min-h-11 shrink-0 items-center justify-center gap-2 rounded-sm border border-border px-5 py-3 text-xs font-bold uppercase tracking-[0.16em] text-primary transition-colors hover:border-primary hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background"
                >
                  Detalhes
                  <ChevronRight size={16} />
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <Link
            to="/eventos"
            className="btn-fpf3-primary inline-flex min-h-11 items-center justify-center gap-2 text-xs"
          >
            Ver calendário completo
            <ChevronRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
